import { useMutation } from 'react-query';

import client from '@/apis/aniftyBackend/client';
import { queryClient } from '@/utils/react-query';

export type SetReminderDTO = {
  data: {
    creationID: number;
    shouldSetReleaseReminder: boolean;
  };
};

export const updateReleaseReminder = ({
  data,
}: SetReminderDTO): Promise<boolean> => {
  // Set release reminder
  if (data.shouldSetReleaseReminder) {
    return client.post('/api/release_reminders', {
      creationID: data.creationID,
    });
  }

  // Cancel release reminder
  return client.delete('/api/release_reminders', {
    params: {
      creationID: data.creationID,
    },
  });
};

export const useUpdateReleaseReminder = ({
  creationID,
}: {
  creationID: number;
}) => {
  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(['releaseReminders', creationID]);
    },
    mutationFn: async ({
      shouldSetReleaseReminder,
    }: {
      shouldSetReleaseReminder: boolean;
    }) =>
      updateReleaseReminder({
        data: {
          creationID,
          shouldSetReleaseReminder,
        },
      }),
  });
};
